import { cn } from "@/lib/utils";

interface ImagePlaceholderProps {
  name: string;
  className?: string;
}

export const ImagePlaceholder = ({ name, className }: ImagePlaceholderProps) => {
  return (
    <div 
      className={cn(
        "w-full h-full flex items-center justify-center bg-accent",
        "text-lg font-medium text-primary/50 px-4 text-center",
        className
      )}
    >
      {name}
    </div>
  );
};